export default __webpack_public_path__ + "static/media/Gloves of Vehement Thunder.4320b373.jpg";